const renderCategory = (categoryID: any) => {
    const language = localStorage.getItem('i18nextLng');
    const keyLanguage = language?.split('-')[0].toUpperCase();
    const category = keyLanguage ? categoryID[keyLanguage] : categoryID.ES;
    return category;
};

export { renderCategory };
